import { GeneralLoadedContent } from './general-loaded-content.interface';
import { LoadingRequestStatus } from './request-status.enum';

export const INITIAL_GENERAL_LOADING_CONTENT: GeneralLoadedContent = {
  content: null,
  loadingStatus: LoadingRequestStatus.loading,
  error: null,
};
